import { formatMoney, priceDrop, type Item } from '@closetly/core';
import { storedImageUrl } from '../lib/image';
import { BookmarkIcon } from './Icons';

interface Props {
  item: Item;
  onOpen: (item: Item) => void;
  onSave: (item: Item) => void;
}

/** A piece as a photo on a board, with its own "Merken" button. */
export function ItemTile({ item: i, onOpen, onSave }: Props) {
  const img = storedImageUrl(i);
  const drop = priceDrop(i);
  const fmt = (c: number) => formatMoney(c, i.currency || undefined);
  return (
    <div className={`tile${i.bought ? ' bought' : ''}`}>
      <button
        type="button"
        className="tile-open"
        aria-label={`${i.name} bearbeiten`}
        disabled={i.pending}
        onClick={() => onOpen(i)}
      >
        {img ? (
          <img src={img} alt="" loading="lazy" />
        ) : (
          <span className="tile-ph">
            <b>{i.name}</b>
            {i.category}
          </span>
        )}
        {i.bought ? (
          <span className="tile-badge">Gekauft</span>
        ) : drop ? (
          <span className="tile-badge drop">−{drop.percent} %</span>
        ) : (
          i.sold_out && <span className="tile-badge out">Ausverkauft</span>
        )}
      </button>
      <button
        type="button"
        className="tile-save"
        aria-label={`${i.name} merken`}
        disabled={i.pending}
        onClick={() => onSave(i)}
      >
        <BookmarkIcon />
      </button>
      <span className="tile-meta">
        <span className="tile-name">{i.name}</span>
        {i.price_cents > 0 && (
          <span className={`tile-price${drop && !i.bought ? ' drop' : ''}`}>
            {drop && !i.bought && <s aria-label={`statt ${fmt(drop.beforeCents)}`}>{fmt(drop.beforeCents)}</s>}
            {fmt(i.price_cents)}
          </span>
        )}
      </span>
    </div>
  );
}
